module.exports = __webpack_public_path__ + "img/week-earn.1f6248f1.svg";